// Match the values the chapter tracker previously read from Semantic UI Visibility.
export const calculateReaderVisibility = (
  rect, pageYOffset, previousOffset, viewportHeight
) => {
  const height = rect.height || 1;
  const bottomPassed = rect.bottom < 0;
  const pixelsPassed = bottomPassed ? 0 : Math.max(-rect.top, 0);
  return {
    height,
    bottomPassed,
    pixelsPassed,
    percentagePassed: pixelsPassed / height,
    topVisible: rect.top >= 0 && rect.top <= viewportHeight,
    direction: pageYOffset > previousOffset ? 'down' : 'up',
  };
};
